import { getCalendarIntegrationEnabled } from './getCalendarIntegrationEnabled';
import { getE2eeIntegrationEnabled } from './getE2eeIntegrationEnabled';

export async function initFeatures(): Promise<void[]> {
  return Promise.all([getCalendarIntegrationEnabled(), getE2eeIntegrationEnabled()]);
}
